import { render, staticRenderFns } from "./DropdownBody.vue?vue&type=template&id=b45bec04&scoped=true"
import script from "./DropdownBody.vue?vue&type=script&lang=js"
export * from "./DropdownBody.vue?vue&type=script&lang=js"
import style0 from "./DropdownBody.vue?vue&type=style&index=0&id=b45bec04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45bec04",
  null
  
)

export default component.exports